const consolidateGetOptionsForActionResponse = (response) => {
	if (response.error || response.message == 'Error: Not found: actions..handler') {
		console.error(`Error occurred while getting data:`, response);
		return {
			errorMessage: response.message,
		};
	}

	return {
		results: response.results,
		hasMoreData: response.pagination?.has_more,
		retrievalId: response.retrieval_id,
	};
};

const consolidateQueryACResponse = (response) => {
	if (response.success) {
		const { data } = response;
		if (data.error) {
			return {
				errorMessage: data.message,
			};
		}
		return {
			results: data.results,
			hasMoreData: data.pagination?.has_more,
			retrievalId: data.retrieval_id,
		};
	}
};

export default {
	consolidateGetOptionsForActionResponse,
	consolidateQueryACResponse,
};
